import React from 'react';
import {
	FingotiButton,
	FingotiModalActions,
	FingotiModalContent,
} from '@fingoti/components';
import { useSnackbar } from 'notistack';

import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '70%',
		},
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	warning: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
		color: theme.palette.error.main,
		marginBottom: theme.spacing(2),
	},
	token: {
		width: '100%',
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '50%',
		},
	},
	button: {
		width: '60%',
	},
}));

export const UserTokenReveal = ({ token, onDone }) => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	if (!token) {
		return null;
	}

	const copyToken = async () => {
		try {
			await navigator.clipboard.writeText(token.token);
			enqueueSnackbar('Token copied to clipboard', { variant: 'success' });
		} catch (error) {
			enqueueSnackbar('Failed to copy token to clipboard', {
				variant: 'error',
			});
		}
	};

	return (
		<>
			<FingotiModalContent>
				<div className={classes.root}>
					<div className={classes.warning}>
						<WarningRoundedIcon />
						<Typography variant='body2'>
							Copy this token now — for security it is shown only once and
							cannot be retrieved again.
						</Typography>
					</div>
					<TextField
						className={classes.token}
						variant='outlined'
						label={token.name}
						value={token.token}
						InputProps={{
							readOnly: true,
							endAdornment: (
								<InputAdornment position='end'>
									<IconButton onClick={copyToken} edge='end'>
										<FileCopyOutlinedIcon />
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</div>
			</FingotiModalContent>

			<FingotiModalActions>
				<div className={classes.buttonGroup}>
					<FingotiButton
						light
						color='primary'
						className={classes.button}
						onClick={() => onDone()}>
						I've saved it
					</FingotiButton>
				</div>
			</FingotiModalActions>
		</>
	);
};
